import React, { useEffect, useState } from "react";
import HeaderActions from "./tabComponents/HeaderActions";
import SearchResults from "./tabComponents/SearchResults";
import Scheduled from "./tabComponents/Scheduled";
import { JobsDataType } from "../types/api-response";
import ListLoader from "./ListLoader";
import NoDataPlaceholder from "./common/NoDataPlaceholder";
import Expired from "./tabComponents/Expired";
import Drafts from "./tabComponents/Drafts";
import {
  useGetDownloadProfilesPollingQuery,
  useLazyCheckEmailQuery,
  useLazyCheckInventoryQuery,
  useLazyDownloadExcelNewQuery,
} from "../redux/apis/manageJobPostingHooks";
import { getUserDetails } from "../utils/getUserDetails";
import CustomSnackbar from "./common/Snackbar/CustomSnackbar";
import { RTKErrorType } from "../types";
import { ENDPOINTS, MIDDLEWARE } from "../constants/api";
import { isValidEmail } from "./mjpModals/DownloadXlsModal";
import { useAppDispatch, useAppSelector } from "../redux/store";
import {
  setEmailString,
  setOpenModal,
} from "../redux/reducers/downloadSlice/downloadSlice";
import { toast } from "react-toastify";
import { extractDomain } from "../utils";
import Inbound from "./tabComponents/Inbound";
import { addDownloadInProgress, isDownloadInProgress } from "../utils/sessionTracker";
import { useDownloadFlyAnimation } from "../utils/useDownloadFlyAnimation";
import { setIsRevamp } from "../redux/reducers/fmSlice/fmSlice";

interface Props {
  active: string;
  setActive: Function;
  jobsData?: JobsDataType[] | undefined;
  isFetching?: boolean;
  isFetchError?: boolean;
  setFilterParams: Function;
}

const ManageJP = ({
  active,
  setActive,
  jobsData,
  isFetching = false,
  isFetchError = false,
  setFilterParams,
}: Props) => {
  const [checkedData, setCheckedData] = useState([]);
  const [parentJobId, setParentJobId] = useState<any>(null);
  const [folderId, setFolderId] = useState<any>(null);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showNotificationToast, setShowNotificationToast] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [completed, setCompleted] = useState<any>([]);
  const [successToastMessage, setSuccessToastMessage] = useState("");
  const [errorToastMessage, setErrorToastMessage] = useState("");
  const [notificationToastMessage, setNotificationToastMessage] = useState("");
  const [processingToastMessage, setProcessingToastMessage] = useState("");
  const [payload, setPayload] = useState({});
  const userDetails = getUserDetails();
  const { handleDownloadFlyAnimation } = useDownloadFlyAnimation();
  const [
    inventoryTrigger,
    {
      isSuccess: isInventorySuccess,
      isError,
      error,
      data,
      isFetching: isInventoryFetching,
    },
  ] = useLazyCheckInventoryQuery();

  const stored = sessionStorage.getItem("dowloadsData");
  const mongo = Object.keys(JSON.parse(stored || "{}"));
  let body1 = mongo
  const isRevampValue = localStorage?.getItem("isRevamp");

  // const {
  //   data: pollingData,
  //   error: pollingError,
  //   isLoading: isPollingLoading,
  //   refetch: refetchPoll,
  //   isSuccess: isPollingSuccess,
  //   isFetching: fetchPoll,
  // } = useGetDownloadProfilesPollingQuery(body1);
  const [
    downloadTrigger,
    {
      isSuccess: isSuccessDownload,
      isError: isErrorDownload,
      error: errorDownload,
      data: dataDownload,
      isFetching: isFetchingDownload,
    },
  ] = useLazyDownloadExcelNewQuery();
  const [
    triggerCheck,
    {
      data: emailData,
      isFetching: isEmailFetching,
      isError: isEmailError,
      isSuccess: isEmailSuccess,
    },
  ] = useLazyCheckEmailQuery();
  const downloadsData = JSON.parse(
    sessionStorage.getItem("dowloadsData") || "{}"
  );
  const inProgressCount = Object.values(downloadsData).filter(
    (item: any) => item.status === "InProgress"
  ).length;
  const onDClick = (jobId: number, event: React.MouseEvent) => {
    if (inProgressCount >= 5) {
      toast.error("You can download up to maximum 5 files at a time.", {
        autoClose: 5000,
        position: "bottom-left",
        hideProgressBar: true,
        theme: "colored",
      });
      return;
    }
    if(isDownloadInProgress(jobId,[0])){
      toast.info("Download is in progress, please wait.", {
        autoClose: 5000,
        position: "bottom-left",
        hideProgressBar: true,
        theme: "colored",
      });
      return;
    }
    sessionStorage.setItem("mjpKey", jobId.toString());
    setFolderId(jobId);
    handleDownloadFlyAnimation(event);
    const bodyy = {
      excelFilters: {
        channel_id: Number(userDetails?.channel_id),
        corp_id: Number(userDetails?.corp_id),
        sub_channel_id: Number(userDetails?.subhchannel_id),
        subuid: Number(userDetails?.recruiter_id),
        site_context: userDetails?.site_context,
        from: 0,
        size: 40,
        filters: {
          folder_search: {
            folder_id: jobId,
            current_state: [0],
          },
        },
        api_profile_flag: 0,
      },
      platform: "MJP Page",
      excelMongoIds:mongo,
    };
    setPayload(bodyy);
    triggerCheck();
  };
  const dispatch = useAppDispatch();
  const emailString: any = useAppSelector(
    (state: any) => state?.download?.emailString
  );

  const EMPTY_FOLDER_MESSAGE = "Folder contains no records. Excel Summary can not be downloaded.";

  const commonToastConfig: any = {
    autoClose: 5000,
    position: "bottom-left",
    hideProgressBar: true,
    theme: "colored",
  };

  const triggerInventory = () => {
    downloadTrigger({
      ...payload,
      mailId: emailData == "Do Nothing" ? null : emailString,
    })
      .then((response: any) => {
        if (response?.error?.data?.message === EMPTY_FOLDER_MESSAGE) {
          setNotificationToastMessage("No profile exists in this folder");
          setShowNotificationToast(true);
        } else {
          // setNotificationToastMessage(
          //   "You can continue with your work. \n You will be notified via email when the file is ready."
          // );
          // setShowNotificationToast(true);
          const data = JSON.stringify(response?.data || {});
          sessionStorage.setItem("dowloadsData", data);

          const channel = new BroadcastChannel("downloads-sync");
          channel.postMessage({ type: "SYNC_DOWNLOADS", payload: data });
          channel.close();
          addDownloadInProgress(folderId)
        }
        
      })
      .catch((error: any) => {
        console.error({ error });
        setNotificationToastMessage("Something went wrong!");
        setShowNotificationToast(true);
      });
  };

  useEffect(() => {
    dispatch(setOpenModal(false));
    if (!isEmailFetching) {
      if (isEmailError) {
        downloadTrigger({
          ...payload,
          mailId: emailData == "Do Nothing" ? null : emailString,
        }).then((response: any)=>{
          if((response?.error?.status === 400 || response?.error?.data?.statusCode === 400) && response?.error?.data?.message){
            if(response?.error?.data?.message === EMPTY_FOLDER_MESSAGE){
              toast.error(
                "No profile exists in this folder",
                {
                ...commonToastConfig,
                  toastId: "error-toast-custom",
                }
              );
            }else{
              toast.error(
                response?.error?.data?.message,
                {
                ...commonToastConfig,
                  toastId: "error-toast-custom",
                }
              );
            } 
            
          }else {
            // toast.info(
            //   "You can continue with your work. \n You will be notified via email when the file is ready.",
            //   {
            //     ...commonToastConfig,
            //     toastId: "info-toast-custom",
            //   }
            // );
            const data = JSON.stringify(response?.data || {});
            sessionStorage.setItem("dowloadsData", data);

            const channel = new BroadcastChannel("downloads-sync");
            channel.postMessage({ type: "SYNC_DOWNLOADS", payload: data });
            channel.close();
          addDownloadInProgress(folderId)
          }
        }).catch((error: any) => {
          console.error({error});
          toast.error(
            "Something went wrong !",
            {
              ...commonToastConfig,
              toastId: "error-toast-custom",
            }
          );
        })
      }

      if (isEmailSuccess) {
        if (emailData == "Do Nothing") {
          downloadTrigger({
            ...payload,
            mailId: emailData == "Do Nothing" ? null : emailString,
          }).then((response: any)=>{
            if((response?.error?.status === 400 || response?.error?.data?.statusCode === 400) && response?.error?.data?.message){
              if(response?.error?.data?.message === EMPTY_FOLDER_MESSAGE){
                toast.error(
                  "No profile exists in this folder",
                  {
                  ...commonToastConfig,
                    toastId: "error-toast-custom",
                  }
                );
              }else{
                toast.error(
                  response?.error?.data?.message,
                  {
                  ...commonToastConfig,
                    toastId: "error-toast-custom",
                  }
                );
              } 
            }else {
              // toast.info(
              //   "You can continue with your work. \n You will be notified via email when the file is ready.",
              //   {
              //     ...commonToastConfig,
              //     toastId: "info-toast-custom",
              //   }
              // );
              const data = JSON.stringify(response?.data || {});
              sessionStorage.setItem("dowloadsData", data);
              
              const channel = new BroadcastChannel("downloads-sync");
              channel.postMessage({ type: "SYNC_DOWNLOADS", payload: data });
              channel.close();
          addDownloadInProgress(folderId)
            }
          }).catch((error: any) => {
            console.error({error});
            toast.error(
              "Something went wrong !",
              {
                ...commonToastConfig,
                toastId: "error-toast-custom",
              }
            );
          })
          
        } else if (isValidEmail(emailData)) {
          dispatch(setEmailString(emailData));
          // dispatch(setOpenModal(true));
          const refvalue = `${extractDomain()}/edge/user-management?tab=contactInfo`
          toast.info(
  <>
    <div
      style={{
        fontSize: "12px",
        textAlign: "left",
        color: "white",
        lineHeight: "20px",
      }}
    >
      Add your email ID on the&nbsp;
      <a
        href={refvalue}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "white",
          fontWeight: 500,
          textDecoration: "underline",
        }}
      >
        Access & Settings
      </a>
      &nbsp;page to proceed with the download.
    </div>
  </>,
  {
    autoClose: 5000,
    position: "bottom-left",
    hideProgressBar: true,
    theme: "colored",
  }
);

        } else if (emailData == "Please provide the mailId") {
          dispatch(setEmailString(""));
          // dispatch(setOpenModal(true));
          const refvalue = `${extractDomain()}/edge/user-management?tab=contactInfo`
          toast.info(
  <>
    <div
      style={{
        fontSize: "12px",
        textAlign: "left",
        color: "white",
        lineHeight: "20px",
      }}
    >
      Add your email ID on the&nbsp;
      <a
        href={refvalue}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "white",
          fontWeight: 500,
          textDecoration: "underline",
        }}
      >
        Access & Settings
      </a>
      &nbsp;page to proceed with the download.
    </div>
  </>,
  {
    autoClose: 5000,
    position: "bottom-left",
    hideProgressBar: true,
    theme: "colored",
  }
);

        }
      }
    }
  }, [isEmailFetching, emailData, isEmailSuccess, isEmailError]);
  useEffect(() => {
    if (isValidEmail(emailData)) {
      dispatch(setEmailString(emailData));
    }
  }, [emailData]);

  const tabList = {
    Active: (
      <SearchResults
        checkedData={checkedData}
        setCheckedData={setCheckedData}
        jobsData={jobsData}
        onDClick={onDClick}
        triggerInventory={triggerInventory}
      />
    ),
    Inbound_Jobs:(
      <Inbound
        checkedData={checkedData}
        setCheckedData={setCheckedData}
        jobsData={jobsData}
        onDClick={onDClick}
        triggerInventory={triggerInventory}
      />
    ),
    Drafts: <Drafts jobsData={jobsData} />,
    Scheduled: (
      <Scheduled
        jobsData={jobsData}
        onDClick={onDClick}
        triggerInventory={triggerInventory}
      />
    ),
    Expired: (
      <Expired
        jobsData={jobsData}
        onDClick={onDClick}
        triggerInventory={triggerInventory}
        checkedData={checkedData}
        setCheckedData={setCheckedData}
      />
    ),
  };

  const ELIGIBLE_HEADER_LIST = ["Active","Inbound_Jobs", "Expired"];
  const baseURL = window.location.origin;

  useEffect(() => {
    // clearing checked rows when tab changes
    setCheckedData([]);
  }, [active]);

  useEffect(()=>{
    if(isRevampValue){
      const isRevamp = isRevampValue !== null ? isRevampValue === "true" : true;
      dispatch(setIsRevamp(isRevamp))
    }
  },[isRevampValue])

  function formatTextWithLineBreaks(text: string) {
    const lines = text.split("\n");

    return (
      <div>
        {lines.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    );
  }

  const CustomToast = ({
    message,
    closeToast,
    onClick,
  }: {
    message: string;
    closeToast?: any;
    onClick: any;
  }) => {
    return (
      <div>
        {formatTextWithLineBreaks(message)}
        <div
          onClick={() => {
            onClick();
            closeToast();
          }}
        >
          Open
        </div>
      </div>
    );
  };
  // useEffect(() => {
  //   if (pollingData && Object.keys(pollingData).length > 0) {
  //     const json = JSON.stringify(pollingData);
  //     sessionStorage.setItem("dowloadsData", json);
  //     const channel = new BroadcastChannel("downloads-sync");
  //     channel.postMessage({ type: "SYNC_DOWNLOADS", payload: json });
  //     channel.close();
  //   }
  
  //   const fetchData = () => {
  //     const downloadsData = JSON.parse(sessionStorage.getItem("dowloadsData") || "{}");
  //     if (Object.keys(downloadsData).length > 0) {
  //       refetchPoll(); 
  //     }
  //   };
  
  //   const intervalId = setInterval(fetchData, 30000); 
  
  //   return () => clearInterval(intervalId);
  // }, [pollingData]);
  
  // const handleDownload = (data: any) => {
  //   if (pollingData?.downloadUrls.length) {
  //     let a = [...completed];
  //     a.push(data.folderId);
  //     setCompleted(a);
  //     window.open(data?.downloadUrl, "_parent");
  //   }
  // };
  // useEffect(() => {
  //   // console.log("kkkkkk", pollingData, completed);
  //   pollingData?.downloadUrls.forEach((data) => {
  //     if (!completed.includes(data.folderId) && data?.downloadUrl) {
  //       toast.success(
  //         <CustomToast
  //           message={`Your file '${data.folderName}' is ready to `}
  //           onClick={() => {
  //             let a = [...completed];
  //             a.push(data.folderId);
  //             setCompleted(a);
  //             handleDownload(data);
  //           }}
  //         />,
  //         {
  //           ...commonToastConfig,
  //           toastId: "success-toast-custom",
  //         }
  //       );
  //     }
  //   });
  // }, [pollingData, completed]);

  if (isFetching) {
    return (
      <div className="m-t-16">
        <ListLoader />
      </div>
    );
  } else if (isFetchError) {
    return (
      <div className="m-t-16" style={{ background: "#fff" }}>
        <NoDataPlaceholder
          text={
            <div>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  margin: "12px 0",
                }}
              >
                Something went wrong, please try again.
              </div>
            </div>
          }
        />
      </div>
    );
  } else {
    return (
      <div className="m-t-16">
        {(jobsData || []).length > 0 &&
          ELIGIBLE_HEADER_LIST.includes(active) && (
            <HeaderActions
              totalRowData={jobsData}
              checkedData={checkedData}
              setCheckedData={setCheckedData}
              active={active}
            />
          )}
        {tabList[active as keyof typeof tabList]}
      </div>
    );
  }
};

export default ManageJP;
